import type { LayerConfigMap } from '@growtherapy/analytics/client';

import { INTAKE_SUMMARY_LAYER_PARAM, PROVIDER_INTAKE_REVIEW_LAYER } from './delayedExperiments';

/**
 * Minimal layer config for delayed experiments that telehealth participates in.
 * Banner UI stays in the provider portal; telehealth only needs allocation + experience.
 */
export const LAYER_CONFIGS = {
  [PROVIDER_INTAKE_REVIEW_LAYER]: {
    exposurePages: ['/provider', '/provider/*'],
    team: 'care-delivery',
    params: {
      [INTAKE_SUMMARY_LAYER_PARAM]: {
        param: INTAKE_SUMMARY_LAYER_PARAM,
        fallback: false,
        evaluationSource: 'client',
        logExposureAt: 'client',
        applyPages: ['/provider', '/provider/*'],
        waitFor: ['userAuthenticated'],
        exposureMechanism: 'component',
      },
    },
  },
} as const satisfies LayerConfigMap;
